import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import * as AccountActions from './account.actions';
import { AccountService } from '../../services/account.service'; // Adjust based on your actual service

@Injectable()
export class AccountEffects {

  validatePassword$ = createEffect(() => this.actions$.pipe(
    ofType(AccountActions.validatePassword),
    switchMap((action) =>
      this.accountService.validatePassword(action.password).pipe(
        map(response => AccountActions.validatePasswordSuccess({ message: response.message })),
        catchError((error) => of(AccountActions.validatePasswordFailure({ error: error.message })))
      )
    )
  ));

  deleteAccount$ = createEffect(() => this.actions$.pipe(
    ofType(AccountActions.deleteAccount),
    switchMap(() => this.accountService.deleteAccount().pipe(
      map(response => AccountActions.deleteAccountSuccess({ message: response.message })),
      catchError(error => of(AccountActions.deleteAccountFailure({ error: error.message })))
    ))
  ));

  constructor(
    private actions$: Actions,
    private accountService: AccountService
  ) {}
}
